// extracted by mini-css-extract-plugin
export default {"container":"LoginFooter--container--2dca5e","logo":"LoginFooter--logo--7b1561","footerLinks":"LoginFooter--footerLinks--f61f4d","footerLink":"LoginFooter--footerLink--dd355d"};